import React, { Component } from "react";
import './_tab.scss';

class TabSelection extends Component {
  handleClick = (value) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(value);
    }
  };

  render() {
    const { tabs, activeTab, title } = this.props;

    return (
      <div className="tab-selection">
        <div className="tabs">
          {tabs.map((tab) => (
            <button
              key={tab.value}
              className={activeTab === tab.value ? "tab active" : "tab"}
              onClick={() => this.handleClick(tab.value)}
            >
              <i className={tab.icon}></i> {tab.label}
            </button>
          ))}
        </div>
        <div className="mt-1">{title && <h4>{title}</h4>}</div>
      </div>
    );
  }
}
export default TabSelection;